import React from 'react';
import uuid from "uuid";
import $ from 'jquery';

import ActionTypes from "./../../actionTypes";
import * as Misc from "./../../misc";
import HelpBalloonView from "./../helpBalloonView";
import Analytics from './../../analytics';

export default class HelpIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBalloonVisible: false,
      id: uuid.v4()
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.HIDE_HELP_BALLOON, (e, data) => this.handleHideHelpBalloon(e, data));
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.HIDE_HELP_BALLOON, (e, data) => this.handleHideHelpBalloon(e, data));
  }

  handleHideHelpBalloon = (e, data) => {
    if (this.state.id !== data.sender) {
      this.setState({isBalloonVisible: false});
    }
  };

  click = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent('help-balloon-show: ' + this.props.title);
    this.setState({isBalloonVisible: true});
    $(document).trigger(ActionTypes.HIDE_HELP_BALLOON, {sender: this.state.id});
  };

  handleBalloonClick = () => {
    Analytics.sendClickEvent('help-balloon-close: ' + this.props.title);
    const lightbox = $('.help-balloon-wrapper');
    lightbox.length
      ? lightbox.slideUp(600, ()=> this.setState({isBalloonVisible: false}))
      : this.setState({isBalloonVisible: false});
  };

  render() {
    const {feature} = this.props;
    if (!feature.description) {
      return null;
    }

    const helpIconClass = this.props.isRound ? '-circle' : '-square';
    return (
      <div className={"lightbox-help-icon lightbox-help-icon" + helpIconClass} onClick={this.click}>
        {this.state.isBalloonVisible
          ? <HelpBalloonView click={this.handleBalloonClick} title={this.props.title} text={feature.description}/>
          : null}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/projectScope/helpIcon.js